<mat-toolbar class="header">
  <div class="back" mat-dialog-close matTooltip="Atrás" matTooltipPosition="right">
    <mat-icon >arrow_back_ios_new</mat-icon>
  </div>
  <div>
  {{ title }}
  </div>
</mat-toolbar>

<div class="dialog-wrapper" >
  <div #wrapper>
    <form [formGroup]="form">
      <div class="form-row">
        <ng-container >
          <mat-form-field appearance="outline" class="field white-field" subscriptSizing="dynamic">
            <mat-label>Fecha de entrega requerida</mat-label>
            <input matInput [matDatepicker]="estimated_completion_date" [formControl]="requiredDeliveryDate">
            <mat-datepicker-toggle matSuffix [for]="estimated_completion_date"></mat-datepicker-toggle>
            <mat-datepicker #estimated_completion_date></mat-datepicker>
          </mat-form-field>
        </ng-container>
      </div>

      <div>
        <app-inventory-action-form
          [parentFormGroup]="(form | formGroup)"
          [enableDiscounts]="false"
          [onlyInventoriable]="true"
          [showBuyPrice]="true"
          [showTotals]="false"
        >
        </app-inventory-action-form>
      </div>
    </form>
  </div>
</div>

<mat-toolbar class="footer">
  <button mat-raised-button mat-dialog-close> 
    Cancelar
  </button>
  <div class="expander"></div>
  <button mat-raised-button
          type="button"
          color="primary"
          [disabled]="!formValid || loading()"
          (click)="saveForm()">
    @if (loading()) {
      <mat-spinner diameter="30"></mat-spinner>
    } @else {
      Guardar
    }      
  </button>
</mat-toolbar>
